import { isNil } from "lodash";
import Mustache from "mustache";

import { EMPTY_EDITOR_STATE } from "constants/rich-text";
import { parseRichTextFormatToHtml } from "helpers/tickets";
import { IAppearance, IAppearanceRichTextObjectItem } from "store/entities/application-settings/interfaces";

import { calculateTextColor } from "../../../_helpers/previewTemplateCalculateTextColor";

import { ContentType } from "./constants";

const generatePreviewTemplate = (
  contentType: ContentType,
  isVisualBuilderPreview: boolean,
  appearance: IAppearance,
  templates: Record<ContentType, string>,
  exampleTicket: Record<string, string>,
  poweredByFooter: string | undefined,
  hasPoweredByFooter: boolean
): string => {
  let parsedWithCustomDelimiter: string;
  let previewContent = "";
  if (
    contentType === ContentType.HTML &&
    isVisualBuilderPreview &&
    !isNil(appearance?.contentBody?.value) &&
    !isNil(templates[ContentType.HTML])
  ) {
    const parsedAppearance = Object.fromEntries(
      Object.entries({
        ...appearance,
        ...{
          contentBody: {
            value: parseRichTextFormatToHtml((appearance.contentBody as IAppearanceRichTextObjectItem).value.html),
          },
        },
        ...{
          footerBody: {
            value: parseRichTextFormatToHtml(
              appearance.footerBody
                ? (appearance.footerBody as IAppearanceRichTextObjectItem).value.html
                : EMPTY_EDITOR_STATE
            ),
          },
        },
      }).map(([k, v]) => [k, v?.value])
    );
    try {
      if (hasPoweredByFooter) {
        parsedWithCustomDelimiter = Mustache.render(templates[ContentType.HTML], parsedAppearance, {}, ["<%%", "%%>"]);
        parsedWithCustomDelimiter = parsedWithCustomDelimiter.replace(
          "</body>\n</html>",
          `${poweredByFooter}</body>\n</html>`
        );
        previewContent = Mustache.render(parsedWithCustomDelimiter, {
          ...exampleTicket,
          poweredByColor: calculateTextColor(String(appearance.appearanceBodyBgColor1.value)),
        });
      } else {
        parsedWithCustomDelimiter = Mustache.render(templates[ContentType.HTML], parsedAppearance, {}, ["<%%", "%%>"]);
        previewContent = Mustache.render(parsedWithCustomDelimiter, exampleTicket);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
  if (contentType === ContentType.HTML && !isVisualBuilderPreview) {
    try {
      previewContent = Mustache.render(templates[ContentType.HTML], exampleTicket);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  }
  if (contentType === ContentType.PlainText) {
    previewContent = Mustache.render(templates[ContentType.PlainText], exampleTicket);
  }

  return previewContent;
};

export default generatePreviewTemplate;
